import { ClerkMetadataKey } from '@this+that/utils';

export function isSuggestionSoundEnabled(
  unsafeMetadata: Record<string, unknown> | undefined,
): boolean {
  return unsafeMetadata?.[ClerkMetadataKey.SUGGESTION_SOUND_ENABLED] !== false;
}
